/** @format */

import signinImg from "../../../images/pct_signin.svg";
import bcartLogo from "../../../images/bcart_logo.png";
import { FormWrap } from "../../layouts/FormWrap";
import { TextField, Button, ErrorMessage, LinkByAgent } from "../../ui-parts";
import { Box } from "../../layouts/Box";
import { ChangeEventHandler, MouseEventHandler } from "react";
import styled from "styled-components";

const DisplayLogo = styled.img<{ zAccount?: string }>`
  width: ${({ zAccount }) => (zAccount === "bcart" ? "80%" : "")};
  margin-top: ${({ zAccount }) => (zAccount === "bcart" ? "80px" : "")};
`;

const LoginElement = ({
  loginHandler,
  setEmailHandler,
  setPasswordHandler,
  apiErrMsg,
  errMsgs,
  zAccountName,
  zAccount,
}: {
  loginHandler: MouseEventHandler<HTMLButtonElement>;
  setEmailHandler: ChangeEventHandler<HTMLInputElement>;
  setPasswordHandler: ChangeEventHandler<HTMLInputElement>;
  apiErrMsg: {
    err_message: string;
  };
  errMsgs: {
    email: string;
    password: string;
  };
  zAccountName: string;
  zAccount: string;
}) => {
  return (
    <FormWrap>
      <div className="align_center">
        {zAccount === "bcart" ? (
          <>
            <DisplayLogo src={bcartLogo} alt="Bカートクレカ決済" zAccount={zAccount} />
            <h1 className="mt0 mb40">Web申込システム</h1>
          </>
        ) : (
          <>
            <DisplayLogo src={signinImg} alt="WebEntrySystemIcon" zAccount={zAccount} />
            <p className="bold font-xl mt20 mb0">Web申込システム</p>
            <p className="bold font-l mt0 mb0">{zAccountName}</p>
          </>
        )}
        <Box mt_desktop={16}>
          <h1 className="mt4 mb16">ログイン</h1>
        </Box>
      </div>
      <ErrorMessage ApiErrMsg={apiErrMsg.err_message} />
      <TextField
        onChange={setEmailHandler}
        iserror={errMsgs.email}
        type="email"
        id="textfield1"
        label="メールアドレス"
        placeholder="user@cardservice.co.jp"
        fullwidth
      />
      <TextField
        onChange={setPasswordHandler}
        iserror={errMsgs.password}
        type="password"
        id="textfield2"
        label="パスワード"
        fullwidth
        mt={0}
      />
      <Box mt={32} />
      <Button onClick={loginHandler} variant="primary" fullwidth>
        ログイン
      </Button>
      <hr />
      <p className="align_center">
        <LinkByAgent from="/login" to="/reset_password_mail">
          パスワードを忘れた方
        </LinkByAgent>
      </p>
    </FormWrap>
  );
};

export default LoginElement;
